@if (supervisorState) {
    @switch (supervisorState.subPhase) {
        @case (SupervisorSubPhase.WaitingForSupervisor) {
            <app-supervisor-panel
                [inverseColors]="true"
                [message]="'Insert supervisor RFID card to continue'"
                (backClicked)="cancelActionClicked.emit()"
            />
        }

        @case (SupervisorSubPhase.ConfirmAction) {
            @switch (supervisorState.selectedAction) {
                @case (SupervisorAction.ContinueGame) {
                    <app-supervisor-panel
                        title="Continuing game"
                        i18n-title
                        message="Insert croupier RFID card to continue game"
                        i18n-message
                        (backClicked)="cancelActionClicked.emit()"
                    />
                }

                @case (SupervisorAction.VoidGame) {
                    <app-supervisor-panel
                        [title]="titleVoidGame"
                        message="Insert croupier RFID card to confirm changes and continue"
                        i18n-message
                        (backClicked)="cancelActionClicked.emit()"
                    />
                }

                @case (SupervisorAction.FreeHand) {
                    <app-supervisor-panel
                        [title]="titleFreeHand"
                        message="Insert croupier RFID card to confirm changes and continue"
                        i18n-message
                        (backClicked)="cancelActionClicked.emit()"
                    />
                }

                @case (SupervisorAction.ChangeResult) {
                    @if (supervisorState.changedGameResult) {
                        <app-supervisor-panel
                            title="Result changed"
                            i18n-title
                            message="Insert croupier RFID card to confirm changes and continue"
                            i18n-message
                            (backClicked)="cancelActionClicked.emit()"
                        />
                    }
                }

                @case (SupervisorAction.CloseTable) {
                    <app-supervisor-panel
                        [title]="titleCloseTable"
                        message="Insert croupier RFID card to confirm changes and continue"
                        i18n-message
                        (backClicked)="cancelActionClicked.emit()"
                    />
                }
            }
        }

        @case (SupervisorSubPhase.ConfirmGameSelection) {
            <app-supervisor-panel
                [title]="titleConfirmGameSelection"
                message="Insert croupier RFID card to confirm the selection and continue"
                i18n-message
                (backClicked)="cancelActionClicked.emit()"
            />
        }
    }
}
